import { Component, Input, OnInit, Inject } from '@angular/core';
import GuestInvitationMailStatusView from './guest-invitation-mail-status.component.html';
import { EventGuest } from '../../../../shared/models/events/guests/event-guest.model';
import { TranslateService, _ } from '@ngx-translate/core';
import { takeUntil } from 'rxjs';
import { BaseDestroyableComponent } from '../../../../shared/base/base-destroyable.component';

@Component({
  selector: 'guest-invitation-mail-status',
  template: GuestInvitationMailStatusView,
  styles: [`.guest-invitation-mail-status-tag {
    padding: 2px 7px;
    margin-right: 5px;
  }`]
})
export class GuestInvitationMailStatusComponent extends BaseDestroyableComponent implements OnInit {
  @Input() guest: EventGuest;
  popoperText: string | null = null;
  severity: string;

  constructor(@Inject(TranslateService) private translate: TranslateService) { super(); }

  ngOnInit() {
    const conError = this.guest.send_error != null && this.guest.send_error !== '';
    const sinEnviar = !this.guest.invitation_has_been_sent && this.guest.send_status === 'unsent';

    // Caso sin texto traducible: se muestra el error del envio tal cual.
    if (sinEnviar && conError) {
      this.popoperText = this.guest.send_error;
      this.severity = 'danger';
      return;
    }

    let clave: string;
    let sufijo = '';
    if (sinEnviar) {
      clave = 'events.guests.send_status_unsent';
      this.severity = 'warn';
    } else if (this.guest.invitation_has_been_sent && this.guest.send_status === 'unsent' && conError) {
      clave = 'events.guests.send_status_unsent';
      sufijo = ': ' + this.guest.send_error;
      this.severity = 'danger';
    } else {
      clave = _('events.guests.send_status_' + this.guest.send_status);
      this.severity = 'primary';
    }

    // stream() en vez de instant(): instant() devuelve la clave si el diccionario todavia no ha
    // llegado, y el tooltip se quedaba con "events.guests.send_status_mail" hasta recargar.
    this.translate.stream(clave)
      .pipe(takeUntil(this.destroy$))
      .subscribe(texto => { this.popoperText = texto + sufijo; });
  }

  /*

    <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='unsent' && !item.invitation_has_been_sent "><span ng-if="item.send_error!=null && item.send_error!=''" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{item.send_error}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-danger">&nbsp;</span><span ng-if="item.send_error==null || item.send_error ==''" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_unsent}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-warning">&nbsp;</span> </td>
  <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='unsent' && item.invitation_has_been_sent && (item.send_error!=null && item.send_error!='')">  <span popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_unsent}}: {{item.send_error}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-danger">&nbsp;</span> </td>
  <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='unsent' && item.invitation_has_been_sent">  <span popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_print}}: {{item.send_date | toLocalDate | date: 'dd/MM/yyyy'}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-primary">&nbsp;</span> </td>
  <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='print'">  <span popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_print}}: {{item.send_date | toLocalDate | date: 'dd/MM/yyyy'}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-primary">&nbsp;</span> </td>
  <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='mail'">  <span popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_mail}}: {{item.send_date | toLocalDate | date: 'dd/MM/yyyy'}}" popover-append-to-body="true" style="display:block; height: 19px; width: 5px;" class="label label-primary">&nbsp;</span> </td>
  <td style="width: 6px;background-color:#E5F9CA" ng-if="item.type!='group' && item.send_status =='inscription' ">  <span class="label label-default" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover="{{send_status_inscription}}" popover-append-to-body="true" style="display:block; height: 19px;width: 5px;">&nbsp;</span> </td>


   */

}
